export var EmbedModalSize = /*#__PURE__*/function (EmbedModalSize) {
  EmbedModalSize["Large"] = "large";
  EmbedModalSize["Small"] = "small";
  return EmbedModalSize;
}({});